import { render, staticRenderFns } from "./SupportedPlaceholders.vue?vue&type=template&id=1a3a8a8c"
import script from "./SupportedPlaceholders.vue?vue&type=script&lang=js"
export * from "./SupportedPlaceholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3a8a8c')) {
      api.createRecord('1a3a8a8c', component.options)
    } else {
      api.reload('1a3a8a8c', component.options)
    }
    module.hot.accept("./SupportedPlaceholders.vue?vue&type=template&id=1a3a8a8c", function () {
      api.rerender('1a3a8a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/hike/components/SupportedPlaceholders.vue"
export default component.exports